export const UrlNames = {
  Api: 'api',
  Auth: 'auth',
  AuthApi: 'authApi',
  Base: 'base',
  OpenNatterApi: 'openNatterApi',
  TagApi: 'tagApi',
  AccountlessNatalieApi: 'accountlessNatalieApi',
  NatalieApi: 'natalieApi',
} as const;
